import { ref } from '@vue/composition-api'

/**
 * 端末ごとの「レシートプリンタを使うか」設定。
 *
 * - デフォルトは「使う」(ON) で、既存の挙動と互換
 * - OFF にすると、この端末からの接続・印刷をすべてスキップする
 * - 1店舗で複数端末が並列でプリンタ接続することによる接続キュー詰まりを防ぐ目的
 *
 * localStorage に保存 (端末ローカル設定なのでサーバには持たない)
 */

const STORAGE_KEY = 'receiptPrinterDisabled'

const readDisabled = () => {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'true'
  } catch {
    return false
  }
}

// module-singleton: 全ての利用箇所で同じ ref を共有する
const isDisabled = ref(readDisabled())

export default function useReceiptPrinterDeviceSetting() {
  const setDisabled = value => {
    isDisabled.value = value
    try {
      if (value) {
        localStorage.setItem(STORAGE_KEY, 'true')
      } else {
        localStorage.removeItem(STORAGE_KEY)
      }
    } catch {
      // localStorage が使えない環境では in-memory のみ保持
    }
  }

  return {
    // 「使わない (OFF)」状態かどうか
    isDisabled,
    setDisabled,
  }
}

/**
 * 印刷ガード: 端末で印刷が無効化されている場合は false を返す。
 * 印刷起動箇所はこの関数を呼んでから send() を実行することで、
 * 無効端末からの不要な接続/印刷を全て塞ぐ。サイレントに無視するため、
 * ユーザーが OFF にしている端末で印刷ボタンを押しても何も起きない。
 *
 * 使い方:
 *   import { canExecutePrintOnThisDevice } from '@/views/composable/useReceiptPrinterDeviceSetting'
 *
 *   const onPrint = () => {
 *     if (!canExecutePrintOnThisDevice()) return
 *     sendSlipPrint()
 *   }
 *
 * @returns {boolean} 印刷を実行してよければ true
 */
export function canExecutePrintOnThisDevice() {
  return !isDisabled.value
}
